import Vue from 'vue'
import Router from 'vue-router'
import TournamentList from '@/components/TournamentList'
import TournamentMatchList from '@/components/TournamentMatchList'
import MatchLive from '@/components/MatchLive'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    { path: '/', name: 'TournamentList', component: TournamentList },
    { path: '/tournaments/:id/matches', name: 'TournamentMatchList', component: TournamentMatchList },
    { path: '/matches/:id/live', name: 'MatchLive', component: MatchLive },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js